/* global NODE_ENV */

import React from 'react';
import ReactDOM from 'react-dom';

import Header from './components/header';
import Intro from './components/intro';
import Quiz from './components/quiz';
import Score from './components/score';
import Notification from './components/notification';
import './index.scss';

class Main extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      currentScreen: NODE_ENV === 'prod' ? 'intro' : 'intro',
      // currentScreen: NODE_ENV === 'prod' ? 'intro' : 'quiz',
      // currentScreen: NODE_ENV === 'prod' ? 'intro' : 'score',
      labels: undefined,
      currentScore: 0,
      showNotif: false,
    };

    this.loadDatas = this.loadDatas.bind(this);
    this.clicStartQuiz = this.clicStartQuiz.bind(this);
    this.goResult = this.goResult.bind(this);
    this.clicRestart = this.clicRestart.bind(this);
    this.clicLogo = this.clicLogo.bind(this);
    this.toggleNotif = this.toggleNotif.bind(this);
    this.closeNotif = this.closeNotif.bind(this);
  }

  componentDidMount() {
    this.loadDatas();
  }

  async loadDatas() {
    const res = await fetch('datas/datas.json');
    const data = await res.json();
    this.setState({ labels: data });
  }

  goResult(currentScore) {
    this.setState({ currentScore, currentScreen: 'score' });
    this.resetScroll();
  }

  clicRestart() {
    this.setState({ currentScreen: 'intro', currentScore: 0 });
    this.resetScroll();
  }

  clicLogo() {
    this.setState({ currentScreen: 'intro' });
  }

  toggleNotif(bool) {
    this.setState({ showNotif: bool });
  }

  closeNotif() {
    this.setState({ showNotif: false });
  }

  renderScreen() {
    if (this.state.currentScreen === 'quiz') {
      return (
      <Quiz
      labels={ this.state.labels }
      goResult={ this.goResult }
      toggleNotif={ this.toggleNotif }
      />
      );
    }
    if (this.state.currentScreen === 'score') {
      return (
      <Score
      labels={ this.state.labels }
      currentScore={ this.state.currentScore }
      clicRestart={ this.clicRestart }
      />
      );
    }
    return null;
  }

  clicStartQuiz() {
    this.setState({ currentScreen: 'quiz' });
    this.resetScroll();
  }

  resetScroll() {
    window.scroll(0, 0);
  }

  render() {
    if (!this.state.labels) return null;
    if (this.state.currentScreen === 'intro') {
      return (
        <div className="containerIntro">
          <Intro labels={ this.state.labels } clicBegin={ this.clicStartQuiz } />
        </div>
      );
    }
    return (
      <div className="container">
      <Header labels={ this.state.labels } clicLogo={ this.clicLogo } />
      { this.renderScreen() }
      <Notification
        labels={ this.state.labels }
        show={ this.state.showNotif }
        closeNotif={ this.closeNotif }
      />
      </div>
    );
  }
}

// ========================================

ReactDOM.render(
  <Main />,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js